import {deserializeAs, inheritSerialization} from "cerialize";
import {Entity} from "./entity";

@inheritSerialization(Entity)
export class DocumentSharingHistory extends Entity {
  @deserializeAs('allow_add_documents')
  allowAddDocuments: boolean;

  @deserializeAs('recipients')
  recipients: any;

  @deserializeAs('documents')
  documents: any;

  @deserializeAs('mes_documents')
  mesDocuments: any;

  @deserializeAs('expiration_date')
  expirationDate: Date = null;

  @deserializeAs('user')
  user: any;
}
